module.exports = __webpack_public_path__ + "img/consultants1.e2ae6581.png";